import {
  CURRENT_STREAK_LOADING,
  LONGEST_STREAK_LOADING,
  SET_LONGEST_STREAK,
  SET_CURRENT_STREAK,
  CURRENT_MONTH_STREAK_LOADING,
  SET_MONTH_STREAK,
} from '../types'
import axiosInstance from '../../axios/axiosInstance'
import store from '../store'

export const getCompletedStreak = async () => {
  try {
    const response: any = await axiosInstance.get(`tracking/streak/completed`)
    return response?.data || 0
  } catch (err) {
    return 0
  }
}

export const getLongestStreak = async () => {
  try {
    store.dispatch({
      type: LONGEST_STREAK_LOADING,
    })

    const response = await axiosInstance.get(`tracking/streak/longest`)

    store.dispatch({
      type: SET_LONGEST_STREAK,
      payload: response.data?.data || {},
    })
    return response.data?.data
  } catch (error: any) {
    return
  }
}

export const getCurrentStreak = async () => {
  try {
    store.dispatch({
      type: CURRENT_STREAK_LOADING,
    })
    const response = await axiosInstance.get(`tracking/streak/current`)
    store.dispatch({
      type: SET_CURRENT_STREAK,
      payload: response.data || {},
    })
    return response.data
  } catch (err) {
    return null
  }
}
export const getStreakByMonth = async (month: string, year: string) => {
  try {
    store.dispatch({
      type: CURRENT_MONTH_STREAK_LOADING,
    })
    const response = await axiosInstance.get(`tracking/streak/monthly?month=${year}-${month}`)
    const result = response?.data?.data || []
    store.dispatch({
      type: SET_MONTH_STREAK,
      payload: { dates: [...result], month, year },
    })
    return response.data
  } catch (error) {
    store.dispatch({
      type: SET_MONTH_STREAK,
      payload: { dates: [], month, year },
    })
    return error
  }
}
